{
  "journal": {
    "title": "Journal d'évènements",
    "label": "Journal",
    "auto_update": "Mise à jour automatique des événements",
    "error": {
      "generic": "Erreur lors de la récupération de nouveaux événements du serveur"
    },
    "filter": {
      "application": {
        "any": "Tous"
      },
      "event_type": {
        "any": "Tous"
      },
      "instance_id": {
        "any": "Tous"
      }
    }
  }
}
